<template>
	<div id="app">
		<!-- connection screen -->
		<Connect v-if="!isConnected"/>

		<!-- show once connected -->
		<Main v-if="isConnected"/>

		<audio ref="audio"></audio>
	</div>
</template>

<script>
import Main from "@/components/Main";
import Connect from "@/components/Connect";
//import Panel from "@/components/Panel";

import { mapGetters } from "vuex";

export default {
	name: "App",
	computed: {
		...mapGetters(['isConnected', 'combinedOutputStream']),
	},
	watch: {
        "combinedOutputStream": {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (stream, oldStream) {
				if(stream == null) return;

				console.log('INITIATE STREAM', stream)
				this.$refs['audio'].srcObject = stream;
				this.$refs['audio'].play();
            }
		},
	},
	components: {
		Main,
		Connect,
		//Panel
	}
};
</script>

<style>
	#app {
		width: 100%;
		height: 100%;
	}
</style>
